import React from "react";
import RelatorioCard from "../votacao/RelatorioCard";

// Card de relatório da tela de unidades: mesmo componente dos relatórios da votação.
const CardRelatorioUnidade = ({ onClick, label, descricao, icon, disabled, children }) => (
  <RelatorioCard
    icon={icon || "file pdf outline"}
    titulo={label}
    descricao={descricao}
    formato="PDF"
    onGerar={onClick}
    desabilitado={disabled}
  >
    {children}
  </RelatorioCard>
);

export default CardRelatorioUnidade;
